import api from '@/api'
import _ from 'lodash'

export default {
  state: {
    messages: {
      Incoming: [],
      Outgoing: [],
      Deleting: []
    },
    settings: []
  },

  getters: {
    inboxMessages: s => s.messages.Incoming,
    sentMessages: s => s.messages.Outgoing,
    trashMessages: s => s.messages.Deleting,

    categoriesSettings: s => _.filter(s.settings, { type: 'Category' }).map(e => e.value1),
    costSettings: s => _.filter(s.settings, { type: 'Summ' }).map(e => ({
      from: e.value1,
      to: e.value2
    }))[0] || {},
    allSettings: s => s.settings
  },

  mutations: {
    setMessages(s, data) {
      s.messages[data.type] = data.messages;
    },

    setSubscription(s, data) {
      s.settings = data;
    }
  },

  actions: {
    async fetchInbox({dispatch}, { subject }) {
      return await dispatch('fetchMessages', { type: 'Incoming', subject });
    },

    async fetchSent({dispatch}, { subject }) {
      return await dispatch('fetchMessages', { type: 'Outgoing', subject });
    },

    async fetchTrash({dispatch}) {
      return await dispatch('fetchMessages', { type: 'Deleting' });
    },

    async fetchMessages({dispatch, commit}, { type, subject }) {
      let error;

      try {
        const response = await api.get(`/messages`, {
          params: {
            page: 1,
            pageSize: 50,
            type,
            adminSubject: subject
          }
        });
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          commit('setMessages', {
            type: type,
            page: 1,
            pageSize: 50,
            messages: result.messages.map(m => ({
              id: m.id,
              subject: m.subject,
              theme: m.adminSubject ? new api.MessageTheme(m.adminSubject): undefined,
              body: m.message,
              email: m.email,
              phone: m.phone,
              from: type === 'Incoming' ? m.userSecondFio : m.userOwnerFio,
              fromId: type === 'Incoming' ? m.userSecond : m.userOwner,
              to: type === 'Incoming' ? m.userOwnerFio : m.userSecondFio,
              timestamp: new Date(m.time),
              files: m.files,

              reply: m.reply ? {
                user: m.userReplyFio,
                timestamp: new Date(m.replyTime),
                text: m.replyText,
                files: m.replyFiles
              } : undefined
            }))
          })
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async postMessage({dispatch, getters}, { subject, body, to, theme, file, phone, email }) {
      let error;

      try {
        const data = new FormData();

        data.append('value', JSON.stringify({
          message: body,
          subject: to ? subject: undefined,
          userSecond: to,
          adminSubject: to ? undefined : theme.valueOf(),
          phone,
          email
        }));

        if (file) {
          data.append('file', file);
        }

        const response = await api.post(`/messages`, data);
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          try {
            const user =  getters.currentUser;

            await dispatch('fetchUser',  { userId: _.get(user, 'id') });
            await dispatch('fetchSent', {});
          }
          catch(e) {}
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async forwardMessage({dispatch, getters}, { id, email}) {
      let error;

      try {
        const response = await api.post(`/messages/forward/${id}`, {
          email
        });
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          try {
            const user =  getters.currentUser;

            await dispatch('fetchUser',  { userId: _.get(user, 'id') });
            await dispatch('fetchSent', {});
          }
          catch(e) {}
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async replyMessage({dispatch, getters}, { replyFor, subject, body, to, theme, file }) {
      let error;

      try {
        const data = new FormData();

        data.append('value', JSON.stringify({
          reply: replyFor,
          message: body,
          subject: subject,
          userSecond: to,
          adminSubject: theme && theme.valueOf()
        }));

        if (file) {
          data.append('file', file);
        }

        const response = await api.post(`/messages`, data);
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          await dispatch('fetchSent', {});
          await dispatch('fetchUser',  { userId: getters.currentUser.id });
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async moveMessageFromInboxToTrash({dispatch}, { id }) {
      dispatch('moveMessageToTrash', {
        type: 'Incoming',
        messageId: id
      })
    },

    async moveMessageFromSentToTrash({dispatch}, { id }) {
      dispatch('moveMessageToTrash', {
        type: 'Outgoing',
        messageId: id
      })
    },

    async moveMessageToTrash({dispatch, getters}, { type, messageId }) {
      let error;

      try {
        const response = await api.patch(`/messages`, {
          type,
          ids: [messageId]
        });
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          await dispatch('fetchMessages', { type });
          await dispatch('fetchUser', { userId: getters.currentUser.id });
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async deleteMessageFromTrash({dispatch}, { messageId }) {
      let error;

      try {
        const response = await api.delete(`/messages`, {
          ids: [messageId]
        });
        const { status, result, errorCode } = response.data;

        if (status === 200) {

        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },


    async getMessagesSettings({}) {
      let error;

      try {
        const response = await api.get(`/messages/property`);
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          return result;
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async saveMessagesSettings({}, {news, category, remind}) {
      let error;

      try {
        const response = await api.post(`/messages/property`, {
          values: [
            news,
            category,
            remind
          ]
        });
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          return result;
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },


    async getSubscriptionSettings({commit}) {
      let error;

      try {
        const response = await api.get(`/messages/subscribe`);
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          commit('setSubscription', result.subscribes);
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async updateCategorySetting({dispatch, getters}, { categories, isMonitored }) {
      let error;

      try {
        const settings = getters.allSettings;

        categories.forEach(c => {
          const idx = _.findIndex(settings, { type: 'Category', value1: c.id });

          if (isMonitored && idx === -1) {
            settings.push({
              type: 'Category',
              value1: c.id
            });
          }
          else if (!isMonitored && idx !== -1) {
            settings.splice(idx, 1);
          }
        });

        const response = await api.post(`/messages/subscribe`, { subscribes: settings });
        const { status, errorCode } = response.data;

        if (status === 200) {
          await dispatch('getSubscriptionSettings');
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async updateCostSetting({dispatch, getters}, { from, to }) {
      let error;

      try {
        const settings = getters.allSettings;
        const idx = _.findIndex(settings, { type: 'Summ' });

        if (idx === -1) {
          settings.push({
            type: 'Summ',
            value1: from,
            value2: to
          });
        }
        else if (idx !== -1) {
          settings[idx].value1 = from;
          settings[idx].value2 = to;
        }

        const response = await api.post(`/messages/subscribe`, { subscribes: settings });
        const { status, errorCode } = response.data;

        if (status === 200) {
          await dispatch('getSubscriptionSettings');
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    }
  }
}
